<template>
  <img
    width="100%"
    :src="shareInfo.activityTempletUrl"
    alt
  />
</template>

<script>
export default {
  props: {
    shareInfo: Object
  },
};
</script>
        
<style scoped>

</style>
